import React from 'react';
import { useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';

import './mobile-notify-alert-modal-style.scss';
import Typography from '@src/componentsNew/Typography/Typography';
import Button from '@src/componentsNew/Buttons/Button';

import { mobileOTPVerificationUrl } from '@src/app/routes';

interface IProps {
  open: boolean;
  onClose?: any;
}

const MobileNotifyAlertModal = ({ open, onClose }: IProps) => {
  const history = useHistory();

  return (
    <Modal open={open} onClose={onClose} onClick={(e) => e.stopPropagation()}>
      <div className="mobile-notify-alert-modal-content">
        <Typography cName="bold-text" variant="subtitle1" component="p" style={{ color: '#090A0FDE' }}>
          Please verify your mobile number
          <br />
          to get a notification 🔔
        </Typography>

        <Typography cName="normal-text" variant="body3" component="p" style={{ color: '#11141D99' }}>
          You might miss out on
          <br />
          Restock & benefits updates
        </Typography>

        <div className="btn-wrapper">
          <Button size="large" variant="contained" onClick={onClose}>
            Cancel
          </Button>
          <Button size="large" variant="contained" onClick={() => history.push(mobileOTPVerificationUrl)}>
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MobileNotifyAlertModal;
